import { AfterViewInit,Component,EventEmitter,forwardRef,OnChanges,OnInit,Output } from '@angular/core';
import { ControlValueAccessor,NG_VALUE_ACCESSOR } from '@angular/forms';
import { DialogService } from '@app/old-ui/dialog/dialog.service';
import { FileUploadBase } from '../file-upload-base/file-upload-base.component';

@Component({
	selector: 'file-upload',
	templateUrl: './file-upload.component.html',
	styleUrls: ['./file-upload.component.scss'],
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(()=>FileUploadComponent),
			multi: true
		},
	]	
})
export class FileUploadComponent extends FileUploadBase implements AfterViewInit, ControlValueAccessor, OnChanges, OnInit{
	@Output() valueChange=new EventEmitter<File>();

	public value:File;

	public constructor(
		dialog:DialogService
	){
		super(dialog);
	}

	ngOnInit(){
		if(!this.labelText)
			this.labelText="Drag and drop a file here or click to browse";
	}
	
	public filesSelected(files:File[]){
		let file=files[0] ?? null;
		if(file){
			if(!this.acceptsFile(file)){
				file=null;
				this.setTemporyStatus('bad-type');
			}
		}
		if(this.value!==file){
			this.value=file;
			if(!this.value &&  this.inputFile?.nativeElement)
				this.inputFile.nativeElement.value=null;
			this.propagateChange(this.value);
			this.valueChange.emit(this.value);
		}
	}

	public writeValue(value:File){
		this.value=value;
		if(!value && this.inputFile?.nativeElement)
			this.inputFile.nativeElement.value=null;
	}

	private propagateChange=(_:File)=>{};

	public registerOnChange(fn:(_:File)=>{}){
		this.propagateChange=fn;
	}

	public registerOnTouched(){}

	public setDisabledState(disabled:boolean){
		//impliment me
	}
}
